import componentSwitch from 'utils/componentSwitch';

import { Checkbox as GeneralCheckbox } from './checkbox';
import { Checkbox as OverlayStyledCheckbox } from './checkbox.overlay';

export const Checkbox = componentSwitch(GeneralCheckbox, OverlayStyledCheckbox);

export default Checkbox;
